import { createContext, useContext } from "react";

import { IMultistepContext } from "./types";

export const MultistepContext = createContext<IMultistepContext | null>(null);

export const useMultistep = () => {
  const context = useContext(MultistepContext);

  if (!context) {
    throw new Error("You can only use this context inside a Multistep component.");
  }

  return context;
};
